import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import {
  Loading,
  MessageBox,
  Message,
  Input,
  InputNumber,
  Button,
  Upload,
  Select,
  Option,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Form,
  FormItem,
  DatePicker,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Slider,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Steps,
  Step,
  Card,
  Collapse,
  CollapseItem,
  Tabs,
  TabPane,
  Tree,
  Alert,
  Badge,
  Progress,
  Rate,
  Tag,
  Empty,
  Cascader,
  CascaderPanel
} from 'element-ui'

Vue.use(Loading.directive)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Upload)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Slider)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Card)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tree)
Vue.use(Alert)
Vue.use(Badge)
Vue.use(Progress)
Vue.use(Rate)
Vue.use(Tag)
Vue.use(Empty)
Vue.use(Cascader)
Vue.use(CascaderPanel)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message



// WEBPACK FOOTER //
// ./src/plugins/element.js